import { render, staticRenderFns } from "./MinhasLicitacoesTituloSecao.vue?vue&type=template&id=24e261e0"
import script from "./MinhasLicitacoesTituloSecao.vue?vue&type=script&lang=js"
export * from "./MinhasLicitacoesTituloSecao.vue?vue&type=script&lang=js"
import style0 from "./MinhasLicitacoesTituloSecao.vue?vue&type=style&index=0&id=24e261e0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports